import { X, Loader2, Clock3, MessageSquare } from "lucide-react";
import { STATE_ICONS, STATE_COLOR, EUR } from "./states";

function StateGrid({ targetStates, sending, onClick }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 mb-4">
      {targetStates.map((s) => {
        const Icon = STATE_ICONS[s.id] || Clock3;
        const color = STATE_COLOR[s.id] || "bg-slate-100 text-slate-700 border-slate-200";
        return (
          <button key={s.id} onClick={() => onClick(s.id)} disabled={sending}
            data-testid={`state-btn-${s.id}`}
            className={`p-2.5 border rounded flex flex-col items-center gap-1 hover:border-[#0F1829] hover:shadow-sm transition disabled:opacity-40 ${color}`}>
            <Icon size={18} />
            <span className="text-[10px] font-mono uppercase tracking-[0.1em] opacity-70">{s.id}</span>
            <span className="text-[11px] font-medium text-center leading-tight">{s.label}</span>
          </button>
        );
      })}
    </div>
  );
}

export default function TransitionModal({
  order, availableStates,
  notes, setNotes, sendEmail, setSendEmail,
  rastreamento, setRastreamento,
  sending, onClose, onTransition, onSendMessage,
}) {
  if (!order) return null;
  const targetStates = availableStates.filter((s) => s.id !== order.state_id);
  const canSendMessage = (notes || "").trim().length > 0 && !sending;
  return (
    <div className="fixed inset-0 bg-black/40 z-50 grid place-items-center p-4 overflow-y-auto" onClick={onClose} data-testid="transition-modal">
      <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-lg shadow-2xl w-full max-w-2xl max-h-[calc(100dvh-2rem)] overflow-y-auto overscroll-contain">
        <div className="flex items-center justify-between px-5 py-3 border-b border-[#E6E1D6] bg-[#F5F2EB] sticky top-0 z-10">
          <div>
            <p className="text-[10px] uppercase tracking-[0.18em] text-[#978D78]">Alterar estado da encomenda</p>
            <p className="text-base font-semibold">#{order.ID_Encomenda} · {order.NomeCompleto || '—'} · {EUR(order.PrecoFinal)}</p>
          </div>
          <button onClick={onClose} className="text-[#6B7280] hover:text-[#0F1829]"><X size={18} /></button>
        </div>
        <div className="p-5">
          <p className="text-xs text-[#4B5563] mb-3">Estado actual: <span className="font-semibold text-[#0F1829]">«{order.state_label}»</span>. Escolhe o novo estado:</p>
          <StateGrid targetStates={targetStates} sending={sending} onClick={onTransition} />
          <label className="text-[10px] uppercase tracking-[0.15em] text-[#978D78]">Observação / Mensagem ao cliente</label>
          <textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows={3}
            data-testid="transition-notes"
            placeholder="Escreve aqui — usada como observação na mudança de estado OU como mensagem ao cliente (sem mudar estado)."
            className="w-full mt-1 px-3 py-2 text-sm border border-[#E6E1D6] rounded outline-none focus:border-[#0F1829]" />

          <label className="text-[10px] uppercase tracking-[0.15em] text-[#978D78] mt-3 block">
            Código de rastreamento <span className="text-[#978D78] normal-case tracking-normal">(aplicado ao transitar para EV · máx 70 car.)</span>
          </label>
          <input type="text" value={rastreamento || ""} onChange={(e) => setRastreamento(e.target.value)}
            maxLength={70} placeholder="Ex: CTEX123456789PT"
            data-testid="transition-rastreamento"
            className="w-full mt-1 px-3 py-2 text-sm border border-[#E6E1D6] rounded outline-none focus:border-[#0F1829] font-mono" />

          <label className="flex items-center gap-2 mt-3 cursor-pointer select-none">
            <input type="checkbox" checked={sendEmail} onChange={(e) => setSendEmail(e.target.checked)}
              data-testid="transition-send-email"
              className="w-4 h-4 accent-[#0F1829]" />
            <span className="text-sm text-[#0F1829]">Enviar email ao cliente (na transição de estado)</span>
          </label>
          <p className="text-[11px] text-[#6B7280] ml-6 mt-0.5">
            Aplica-se às mudanças de estado. O botão "Enviar mensagem" abaixo notifica sempre o cliente por email.
          </p>

          {/* Send message keeping the current state */}
          <div className="mt-4 pt-3 border-t border-[#E6E1D6] flex flex-wrap items-center justify-between gap-2">
            <div className="text-xs text-[#6B7280]">
              <strong className="text-[#0F1829]">Sem mudar de estado</strong> — regista a mensagem no histórico e envia-a por email ao cliente.
            </div>
            <button onClick={onSendMessage} disabled={!canSendMessage}
              data-testid="transition-send-message"
              className="px-3 py-2 text-xs rounded bg-white border border-[#0F1829] text-[#0F1829] hover:bg-[#0F1829] hover:text-white transition inline-flex items-center gap-1.5 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-[#0F1829]">
              {sending ? <Loader2 size={13} className="animate-spin" /> : <MessageSquare size={13} />}
              Enviar mensagem (mantém estado)
            </button>
          </div>

          {sending && <p className="text-xs text-[#6B7280] mt-2"><Loader2 size={12} className="inline animate-spin mr-1" /> A aplicar...</p>}
        </div>
      </div>
    </div>
  );
}
